import { useCallback, useRef, useState } from 'react'

export function useThreadState() {
    const [hideToolCalls, setHideToolCalls] = useState(false)
    const [input, setInput] = useState('')
    const [firstTokenReceived, setFirstTokenReceived] = useState(false)

    const lastError = useRef<string | undefined>(undefined)
    const textareaRef = useRef<HTMLTextAreaElement>(null)
    const prevMessageLength = useRef(0)

    const clearInput = useCallback(() => {
        setInput('')
    }, [])

    const setFirstToken = useCallback((received: boolean) => {
        setFirstTokenReceived(received)
    }, [])

    return {
        // State
        hideToolCalls,
        input,
        firstTokenReceived,

        // Refs
        lastError,
        textareaRef,
        prevMessageLength,

        // Actions
        setHideToolCalls,
        setInput,
        clearInput,
        setFirstToken,
        setFirstTokenReceived
    }
}
